import type { MailboxInfo } from "owa-client-types";
import getResourceTokenAuthInfoBarStore from "./store/resourceTokenAuthInfoBarStore";

export function hasResourceTokenAuthInfoBarRequest(mailboxInfo: MailboxInfo): boolean {
    return !!getResourceTokenAuthInfoBarStore(mailboxInfo)?.request;
}
